module.exports = __webpack_public_path__ + "img/kabutocho-light.36f2ad0.svg";